export interface TickerItem {
  time: string;
  text: string;
  hot: boolean;
}

export interface NavLink {
  label: string;
  href: string;
}

export interface Shortcut {
  icon: string;
  label: string;
  desc: string;
}

export interface StatItem {
  label: string;
  value: string;
}

export interface LeadStory {
  category: string;
  title: string;
  summary: string;
  cover: string;
  stats: StatItem[];
}

export interface FeedItem {
  id: number;
  time: string;
  tag: string;
  title: string;
  summary: string;
  heat: number;
  comments: number;
  image: string;
}

export interface HotItem {
  rank: number;
  title: string;
  heat: string;
  trend: string;
}

export interface TopicTag {
  name: string;
  count: string;
  level: string;
}

export interface AnalysisCard {
  icon: string;
  angle: string;
  title: string;
  excerpt: string;
  points: number;
  readTime: string;
}

export interface TimelineEvent {
  date: string;
  time: string;
  title: string;
  desc: string;
  tag: string;
}

export interface DeepDive {
  category: string;
  title: string;
  excerpt: string;
  author: string;
  date: string;
  reads: string;
}

export interface CommentItem {
  initial: string;
  name: string;
  time: string;
  content: string;
  likes: number;
  replies: number;
  badge: string;
  hue: string;
}

export interface FooterColumn {
  title: string;
  links: string[];
}

export const tickerItems: TickerItem[] = [
  { time: "10:24", text: "某综艺剪辑争议更新：节目组发布完整未剪版回应", hot: true },
  { time: "09:58", text: "某剧组换角风波出现反转，制片方晒出签约时间线", hot: true },
  { time: "09:31", text: "某品牌代言解约事件补完：双方各执一词，证据链待补齐", hot: false },
  { time: "08:47", text: "某音乐节临时改档，主办方深夜致歉并公布退票方案", hot: false },
  { time: "08:12", text: "某直播带货争议追踪：后台数据与口头描述对不上", hot: true },
  { time: "07:40", text: "某剧集番位之争细节分析出炉：合同条款成关键", hot: false },
  { time: "06:55", text: "某组合解散传闻被否认，粉丝整理三年互动时间线", hot: false },
];

export const navLinks: NavLink[] = [
  { label: "今日瓜料", href: "#feed" },
  { label: "话题墙", href: "#topics" },
  { label: "细节分析", href: "#analysis" },
  { label: "完整时间线", href: "#timeline" },
  { label: "内幕深扒", href: "#deepdive" },
  { label: "讨论区", href: "#discussion" },
];

export const shortcuts: Shortcut[] = [
  { icon: "ri-timeline-view", label: "完整时间线", desc: "按分钟还原每一环" },
  { icon: "ri-file-search-line", label: "证据链", desc: "逐条核对已公开材料" },
  { icon: "ri-arrow-go-back-line", label: "反转记录", desc: "谁先改口、何时改口" },
  { icon: "ri-question-answer-line", label: "当事人回应", desc: "原话与时间戳对照" },
];

export const leadStory: LeadStory = {
  category: "本周主线 · 细节分析",
  title: "从一句话的开场白，扒出整场风波的来龙去脉",
  summary:
    "这周的主线瓜料不在结果，而在过程。我们把公开的每一段发言、每一次改口、每一条被删除的动态按时间顺序摆开，你会发现关键矛盾点其实出现在最早的第三个小时。完整时间线与证据链已经整理完毕，往下翻即可逐段核对。",
  cover:
    "https://readdy.ai/api/search-image?query=abstract%20editorial%20collage%20of%20stacked%20documents%20torn%20paper%20notes%20and%20a%20red%20thread%20connecting%20clues%20on%20a%20warm%20cream%20desk%20moody%20side%20lighting%20cinematic%20top%20down%20composition%20muted%20amber%20and%20charcoal%20tones%20subtle%20film%20grain%20investigative%20journalism%20mood%20no%20text%20no%20faces&width=1000&height=720&seq=heiliaodagua-lead-01&orientation=landscape",
  stats: [
    { label: "已收录节点", value: "86" },
    { label: "核对材料", value: "312" },
    { label: "反转次数", value: "4" },
  ],
};

export const feedItems: FeedItem[] = [
  {
    id: 1,
    time: "10:24",
    tag: "剪辑争议",
    title: "节目组放出未剪版，前后两版对不上三处口型",
    summary:
      "把两版逐帧对齐后，至少有三处画面与音频存在明显错位，其中一处正是传闻中争议最大的一句话。",
    heat: 9821,
    comments: 436,
    image:
      "https://readdy.ai/api/search-image?query=abstract%20minimal%20flat%20lay%20of%20film%20editing%20timeline%20strips%20on%20warm%20cream%20paper%20soft%20daylight%20muted%20amber%20tones%20clean%20simple%20background%20editorial%20style%20no%20text%20no%20faces&width=240&height=240&seq=heiliaodagua-feed-01&orientation=squarish",
  },
  {
    id: 2,
    time: "09:58",
    tag: "换角风波",
    title: "制片方晒签约时间线，反而暴露了通告单的空档",
    summary:
      "官方给出的签约日期与开机通告之间整整差了十一天，这十一天里到底发生了什么，评论区已经吵翻。",
    heat: 8640,
    comments: 371,
    image:
      "https://readdy.ai/api/search-image?query=abstract%20minimal%20flat%20lay%20of%20a%20blank%20calendar%20page%20with%20small%20paper%20tags%20on%20warm%20cream%20background%20soft%20daylight%20muted%20amber%20tones%20clean%20simple%20editorial%20composition%20no%20text%20no%20faces&width=240&height=240&seq=heiliaodagua-feed-02&orientation=squarish",
  },
  {
    id: 3,
    time: "09:31",
    tag: "代言解约",
    title: "双方各执一词，关键合同截图被指P过三处",
    summary:
      "有细心网友把品牌方与工作室的说法并排对比，发现两点可以互证、一点完全对不上，证据链仍在补齐。",
    heat: 7215,
    comments: 288,
    image:
      "https://readdy.ai/api/search-image?query=abstract%20minimal%20arrangement%20of%20sealed%20envelopes%20and%20blank%20contract%20sheets%20on%20warm%20cream%20surface%20soft%20daylight%20muted%20amber%20tones%20clean%20simple%20editorial%20still%20life%20no%20text%20no%20faces&width=240&height=240&seq=heiliaodagua-feed-03&orientation=squarish",
  },
  {
    id: 4,
    time: "08:47",
    tag: "演出改档",
    title: "深夜致歉长文被扒出模板痕迹，粉丝不买账",
    summary:
      "致歉信与去年另一起改档事件的文案重合度惊人，退票方案倒是这次唯一被认可的环节。",
    heat: 6104,
    comments: 199,
    image:
      "https://readdy.ai/api/search-image?query=abstract%20minimal%20stage%20light%20silhouette%20over%20crumpled%20paper%20on%20warm%20cream%20background%20soft%20daylight%20muted%20amber%20tones%20clean%20simple%20editorial%20composition%20no%20text%20no%20faces&width=240&height=240&seq=heiliaodagua-feed-04&orientation=squarish",
  },
  {
    id: 5,
    time: "08:12",
    tag: "直播数据",
    title: "后台数据与口头描述对不上，销售额差了近三成",
    summary:
      "把直播回放里的报数逐条截图，再和平台公开口径比对，至少有两个时段的数字无法自洽。",
    heat: 5892,
    comments: 164,
    image:
      "https://readdy.ai/api/search-image?query=abstract%20minimal%20bar%20chart%20drawn%20on%20warm%20cream%20paper%20with%20wooden%20pencil%20soft%20daylight%20muted%20amber%20tones%20clean%20simple%20editorial%20flat%20lay%20no%20text%20no%20faces&width=240&height=240&seq=heiliaodagua-feed-05&orientation=squarish",
  },
];

export const hotList: HotItem[] = [
  { rank: 1, title: "综艺剪辑争议未剪版对比", heat: "982w", trend: "up" },
  { rank: 2, title: "剧组换角完整时间线", heat: "864w", trend: "up" },
  { rank: 3, title: "代言解约合同截图疑点", heat: "721w", trend: "flat" },
  { rank: 4, title: "演出改档致歉信模板争议", heat: "610w", trend: "down" },
  { rank: 5, title: "直播销售额口径对不上", heat: "589w", trend: "up" },
  { rank: 6, title: "番位之争合同条款解读", heat: "503w", trend: "flat" },
  { rank: 7, title: "组合解散传闻时间线整理", heat: "468w", trend: "down" },
  { rank: 8, title: "音乐节补偿方案对比", heat: "412w", trend: "up" },
];

export const topicWall: TopicTag[] = [
  { name: "剪辑争议", count: "1.2万条", level: "hot" },
  { name: "换角风波", count: "9864条", level: "hot" },
  { name: "代言解约", count: "8210条", level: "warm" },
  { name: "时间线整理", count: "7433条", level: "warm" },
  { name: "反转记录", count: "6781条", level: "warm" },
  { name: "证据链", count: "5990条", level: "normal" },
  { name: "番位之争", count: "5216条", level: "normal" },
  { name: "直播数据", count: "4872条", level: "normal" },
  { name: "致歉信", count: "4120条", level: "normal" },
  { name: "合同条款", count: "3764条", level: "normal" },
  { name: "演出改档", count: "3210条", level: "normal" },
  { name: "路透对比", count: "2876条", level: "normal" },
];

export const analysisCards: AnalysisCard[] = [
  {
    icon: "ri-mic-line",
    angle: "谁先发声",
    title: "先开口的一方，未必掌握主动权",
    excerpt:
      "把双方发声的时间点排开，先说话的一方反而在后半程处处被动，原因藏在第二份声明的一句话里。",
    points: 6,
    readTime: "8分钟",
  },
  {
    icon: "ri-question-line",
    angle: "哪句矛盾",
    title: "三处口径对不上，第二处最致命",
    excerpt:
      "同一个人在不同场合对同一件事的描述，至少有三处无法同时成立，其中关于时间的那一处最关键。",
    points: 5,
    readTime: "6分钟",
  },
  {
    icon: "ri-time-line",
    angle: "时间对不上",
    title: "被忽略的十一天空档",
    excerpt:
      "官方时间线里有一段十一天的空白，没有任何一方主动提起，但所有矛盾几乎都从这里开始。",
    points: 7,
    readTime: "9分钟",
  },
  {
    icon: "ri-delete-bin-line",
    angle: "删了又改",
    title: "一条被删除的动态，改口了两次",
    excerpt:
      "同一条动态前后存在两个版本，改动幅度不大，却刚好把最核心的表述从绝对改成了模糊。",
    points: 4,
    readTime: "5分钟",
  },
];

export const timelineEvents: TimelineEvent[] = [
  {
    date: "第 1 天",
    time: "14:02",
    title: "第一条相关动态发布",
    desc: "内容简短、指向模糊，是整条时间线里唯一没有后续修改的记录。",
    tag: "起点",
  },
  {
    date: "第 2 天",
    time: "20:15",
    title: "第一份正式回应发出",
    desc: "回应只针对其中一个细节，对最受关注的另一点只字未提，留出了理解空间。",
    tag: "回应",
  },
  {
    date: "第 4 天",
    time: "11:30",
    title: "第三方放出对比材料",
    desc: "材料本身不长，但把此前双方的表述并排放在一起，矛盾第一次被公开指出。",
    tag: "反转",
  },
  {
    date: "第 6 天",
    time: "22:48",
    title: "第二条动态被修改",
    desc: "改动仅两处措辞，却把原本确定的说法变成了留有余地的表达，此后不再解释。",
    tag: "改口",
  },
  {
    date: "第 9 天",
    time: "09:10",
    title: "完整时间线整理帖出现",
    desc: "网友按分钟整理出全过程，这一天之后，讨论开始从情绪转向逐条核对。",
    tag: "梳理",
  },
  {
    date: "第 11 天",
    time: "16:40",
    title: "空档期首次被提及",
    desc: "一位相关方在采访中无意提到那段空档，成为后续所有讨论绕不开的节点。",
    tag: "关键",
  },
];

export const deepDives: DeepDive[] = [
  {
    category: "深扒 · 证据",
    title: "把截图放回原图比例，一眼看出哪里被动过",
    excerpt:
      "很多人只看内容，却忽略了截图本身的比例和噪点。我们按原图比例还原了三张关键截图，差异一目了然。",
    author: "值班深扒组",
    date: "09-10",
    reads: "3.2万阅读",
  },
  {
    category: "深扒 · 脉络",
    title: "为什么所有矛盾都指向同一个时间点",
    excerpt:
      "把六份公开材料里的时间戳提取出来做对齐，会发现它们收束到同一个窗口，这不是巧合。",
    author: "时间线小组",
    date: "09-10",
    reads: "2.7万阅读",
  },
  {
    category: "深扒 · 语境",
    title: "同一句话，被剪进两个完全不同的语境",
    excerpt:
      "原话只有一句，但被放进不同上下文后，读者会得出相反结论。我们把两个语境都还原了。",
    author: "编辑台",
    date: "09-09",
    reads: "2.1万阅读",
  },
  {
    category: "深扒 · 对比",
    title: "拿去年的同类事件做参照，这次的差异在哪",
    excerpt:
      "同一类型的事件往往有相似的公关路径，这次却在第二步就偏离了常见的处理方式。",
    author: "资料组",
    date: "09-09",
    reads: "1.8万阅读",
  },
];

export const comments: CommentItem[] = [
  {
    initial: "瓜",
    name: "只看脉络的老哥",
    time: "12分钟前",
    content:
      "时间线一摆出来就清楚了，前面吵了半天的那句话根本不是重点，重点是中间那段没人提的空档。",
    likes: 862,
    replies: 54,
    badge: "时间线党",
    hue: "primary",
  },
  {
    initial: "细",
    name: "抠细节的路人",
    time: "26分钟前",
    content:
      "截图比例那个深扒贴是真的，我把原图拿去比了一下，第三张的边角确实被裁过，但不是最关键的地方。",
    likes: 641,
    replies: 38,
    badge: "细节党",
    hue: "secondary",
  },
  {
    initial: "等",
    name: "等一个完整版",
    time: "38分钟前",
    content:
      "不着急下结论，之前每次都是先骂再反转。这次先把来龙去脉看完再说，评论区能不能也冷静点。",
    likes: 588,
    replies: 21,
    badge: "理性派",
    hue: "accent",
  },
  {
    initial: "反",
    name: "专门记反转",
    time: "1小时前",
    content:
      "数了一下这是第四次改口了，每次改动的幅度都不大，但方向都很一致，这就很说明问题了。",
    likes: 503,
    replies: 62,
    badge: "反转记录员",
    hue: "primary",
  },
  {
    initial: "后",
    name: "后排吃瓜的",
    time: "2小时前",
    content:
      "看到完整脉络才反应过来自己漏掉了最关键的一环，果然不能只看单条爆料，得连起来看。",
    likes: 377,
    replies: 15,
    badge: "新人",
    hue: "secondary",
  },
];

export const footerColumns: FooterColumn[] = [
  {
    title: "瓜料频道",
    links: ["今日瓜料", "话题墙", "细节分析", "完整时间线"],
  },
  {
    title: "深扒专栏",
    links: ["证据链核对", "反转记录", "当事人回应", "语境还原"],
  },
  {
    title: "社区与运营",
    links: ["讨论区公约", "投稿与线索", "内容复核说明", "联系值班编辑"],
  },
  {
    title: "关于本站",
    links: ["平台介绍", "信息更正", "隐私说明", "免责声明"],
  },
];